import { TableEmptyState } from '@practium/ui';
import type { MockTestimonial } from '../../../types/landing.types';
import styles from '../LandingTable.module.css';

interface TestimonialsTableProps {
	testimonials: MockTestimonial[];
	onRowClick?: (id: string) => void;
}

export const TestimonialsTable = ({ testimonials, onRowClick }: TestimonialsTableProps) => {
	if (testimonials.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum depoimento encontrado"
				subtitle="Adicione um depoimento para começar"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Nome</th>
						<th>Tipo</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{testimonials.map(item => (
						<tr
							key={item._id}
							onClick={() => onRowClick?.(item._id)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.name}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.tipo}</span>
							</td>
							<td>
								<span
									className={`${styles.statusBadge} ${
										item.status === 'active' ? styles.statusActive : styles.statusInactive
									}`}
								>
									{item.status === 'active' ? 'Ativo' : 'Inativo'}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
